import schema from "./schema";
import uiSchema from "./uiSchema";

export default {
    id: 3,
    schemaType: 'booking',
    name: 'program',
    schema: schema,
    uiSchema: uiSchema,
}